import { ReactNode } from 'react'

import { TokensIcon } from '@radix-ui/react-icons'
import { LinkProps, useLocation } from '@tanstack/react-router'
import { HistoryIcon } from 'lucide-react'

export type MenuItem = {
  label: string
  to: LinkProps['to']
  isActive: boolean
  icon: ReactNode
  subMenu?: MenuItem[]
}

export function useMenuAffiliator(): MenuItem[] {
  const { pathname } = useLocation()

  return [
    {
      label: 'Dashboard',
      to: '/affiliate',
      isActive: pathname === '/affiliate',
      icon: <TokensIcon />,
    },
    {
      label: 'Riwayat Poin',
      to: '/affiliate/history',
      isActive: pathname.startsWith('/affiliate/history'),
      icon: <HistoryIcon />,
    },
  ]
}
